import {
    setCookie,
    initializeMap,
    initMenuTrigger,
    initOpenInNewTab,
    aosConfig,
    addScollClass,
    addParalax,
    addFancyboxFixForGallery,
    addCloseCookies,
    initForm,
    googleMapInit,
    initLoadNews
} from './functions';

import gsap from "gsap";


const mainApp = () => {



    // init menu trigger
    initMenuTrigger();

    // init open in new tab
    initOpenInNewTab();

    // init AOS animation config
    aosConfig();

    // add scroll class to body  
    addScollClass('0px');

    // add paralax to element
    //addParalax('.page-id-326 .mainContent');





    // add close function to cookies
    addCloseCookies();



    //start - contact form
    initForm();

    googleMapInit();


    initLoadNews();


}

document.addEventListener("DOMContentLoaded", mainApp, false);


(function ($) {
    const mainAppWithJquery = () => {

        $('.scrollDown').click(function () {

            $('body,html').animate({ scrollTop: ($('.rotator').height() - 50) + 'px' }, 500);
        });
        $('.footer__goToTop').click(function () {

            $('body,html').animate({ scrollTop: '0px' }, 500);
        });

        //rotator and sliders
        if ($('.rotatorTop').length > 0) {
            $('.rotatorTop').slick({
                infinite: true,
                arrows: false,
                dots: false,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
                autoplaySpeed: 5000,
                fade: true,
                cssEase: 'linear',
                pauseOnHover: false,
                pauseOnFocus: false,

            });
            var currentRotSlide = 0;
            $('.rotatorTop').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                currentRotSlide = currentSlide;
                $('.rotatorTop .rotator__slide:nth-child(' + (currentSlide + 1) + ')').addClass('slick-out');
            });
            $('.rotatorTop').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                $('.rotatorTop .rotator__slide:nth-child(' + (currentRotSlide + 1) + ')').removeClass('slick-out');
            });
        }


        if ($('.testimonialsList').length > 0) {
            $('.testimonialsList').slick({
                infinite: true,
                arrows: true,
                dots: false,
                autoplay: true,
                speed: 500,
                autoplaySpeed: 10000,
                slidesToShow: 2,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });

        }

        /*
                if ($('.wp-block-gallery').length > 0) {
                    $('.wp-block-gallery').each(function (i) {
                        let newGallery = $('<div class="newGallery"><h3 class="newGallery__header">' +
                            $(this).find('.blocks-gallery-caption').text() +
                            '</h3><div  class="newGallery__slider slickSliderUi"></div></div>');
                        let tempItem = '';
                        $(this).find('.blocks-gallery-item figure').each(function (index) {
                            if (index % 2 == 0) {
                                tempItem += $(this).html();
                            } else {
                                tempItem += $(this).html();
                                let newItem = $('<div class="newGallery__slide"></div>');
                                newItem.append(tempItem);
                                newGallery.find('.newGallery__slider').append(newItem);
                                tempItem = '';
                            }
                        });
                        $(this).before(newGallery);
                        var idGal = 'gal' + (Math.floor(Math.random() * 100));
                        newGallery.find('a').each(function () {
                            $(this).attr('data-fancybox', idGal);
                            $(this).attr('data-caption', $(this).next('figcaption').html());
                        });
                        $(this).remove();
        
                    });
        
        
        
                }
        
                $('.newGallery__slider').slick({
                    infinite: false,
                    arrows: true,
                    dots: false,
                    autoplay: true,
                    speed: 500,
                    autoplaySpeed: 10000,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    responsive: [
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                            }
                        }
                    ]
                });
                */




        //fix gallery id for slideshow
        addFancyboxFixForGallery('.wp-block-image a');
        addFancyboxFixForGallery('.single-gallery-image a');


        //fancybox
        $(".blocks-gallery-item a, .fancybox, .wp-block-image a, a[data-fancybox]").fancybox({
            /* loop: true,
             margin: [44, 0],
             gutter: 50,
             keyboard: true,
             arrows: true,
             infobar: false,
             toolbar: true,
             buttons: ["slideShow", "fullScreen", "close"],
             idleTime: 4,
             protect: false,
             modal: false,
             animationEffect: "fade",
             animationDuration: 600,
             transitionEffect: "fade",
             transitionDuration: 800*/
            loop: true,
            margin: [44, 0],
            gutter: 50,
            keyboard: true,
            arrows: true,
            infobar: false,
            toolbar: true,
            buttons: ["slideShow", "fullScreen", "thumbs", "close"],
            idleTime: 4,
            protect: false,
            modal: false,
            animationEffect: false,
            animationDuration: 600,
            transitionEffect: "fade",
            transitionDuration: 800,
            //preventCaptionOverlap: true,
            //autoFocus: false,
            backFocus: false,
            thumbs: {
                autoStart: true,                  // Display thumbnails on opening
                hideOnClose: true,                   // Hide thumbnail grid when closing animation starts
                parentEl: '.fancybox-container',  // Container is injected into this element
                axis: 'y'                     // Vertical (y) or horizontal (x) scrolling
            },
            mobile: {
                thumbs: false
            },
            afterShow: function (instance, slide) {
                // console.log(instance);
                //  console.log(slide);

            }
        });

        /*  $(".newGallery__slide a").fancybox({
              loop: true,
              margin: [44, 0],
              gutter: 50,
              keyboard: true,
              arrows: true,
              infobar: false,
              toolbar: true,
              buttons: ["slideShow", "fullScreen", "thumbs", "close"],
              idleTime: 4,
              protect: false,
              modal: false,
              animationEffect: false,
              animationDuration: 600,
              transitionEffect: "fade",
              transitionDuration: 800,
              //preventCaptionOverlap: true,
              //autoFocus: false,
              backFocus: false,
              thumbs: {
                  autoStart: true,                  // Display thumbnails on opening
                  hideOnClose: true,                   // Hide thumbnail grid when closing animation starts
                  parentEl: '.fancybox-container',  // Container is injected into this element
                  axis: 'y'                     // Vertical (y) or horizontal (x) scrolling
              },
              mobile: {
                  thumbs: false
              },
              afterShow: function (instance, slide) {
                  // console.log(instance);
                  //  console.log(slide);
  
              }
          });*/


        $('.calc').calcPrice();




    };
    document.addEventListener("DOMContentLoaded", mainAppWithJquery, false);

})(jQuery);


$.fn.calcPrice = function () {
    // calc
    let calcMenu = $('.calcMenu__menu');
    let calcStep = 1;
    let stepHolder = $('.calc__step.stepNum_' + calcStep);
    let calcStepCount = $('.calc__step').length;

    function moveToTopCalc() {
        $('html,body').animate({ scrollTop: ($('.calc__Steps').offset().top - 260) + 'px' }, 400);
    }

    function setActiveCalcMenu() {
        $('.calcMenu__menu li').removeClass(['active', 'checked', 'checked2']);
        $('.calcMenu__menu li').each(function (i) {

            if (i < calcStep - 1) {
                $(this).addClass('checked');
            } else if (i == calcStep - 1) {
                $(this).addClass('active');
            }
        });
        correctMenuSlider();
    }

    function changeStep() {
        $('.calc__step').removeClass('active');
        stepHolder.addClass('active');
        setActiveCalcMenu();

        if (calcStep > 1) {
            $('.calc__navPrev').removeClass('disabled');
        } else {
            $('.calc__navPrev').addClass('disabled');
        }
        if (calcStep == calcStepCount) {
            $('.calc__navNext').addClass('disabled');
            $('.calc__navSend').addClass('show');
        } else {
            $('.calc__navNext').removeClass('disabled');
            $('.calc__navSend').removeClass('show');
        }

        $('.calc__navStepCount').text(calcStep);

    }

    function validateStep() {

        if (stepHolder.hasClass('type_simple')) {
            if (stepHolder.find('input[type=radio]:checked').length > 0) {
                return true;
            }
        }

        if (stepHolder.hasClass('type_dimensions')) {
            let validate = true;
            stepHolder.find('input:not(:disabled)').each(function (i) {
                if ($(this).val() == '') {
                    validate = false;
                    return false;
                }
            });
            return validate;
        }

        return false;
    }

    function changeStepTo(newStep) {
        if (newStep < calcStep) {
            //wstecz
            calcStep = newStep;
            stepHolder = $('.calc__step.stepNum_' + calcStep);
            changeStep();
            moveToTopCalc();
        } else {
            // w przód
            if (validateStep()) {
                //przechodzimy

                stepHolder.removeClass('error');

                calcStep = newStep;
                stepHolder = $('.calc__step.stepNum_' + calcStep);
                changeStep();

                moveToTopCalc();

            } else {
                // wyświetl alert
                stepHolder.addClass('error');
                moveToTopCalc();
            }
        }

    }


    function correctMenuSlider() {
        let active = $('.calcMenu__item.active');

        let left = active.offset().left - calcMenu.offset().left + (active.offset().left - (window.innerWidth / 2) - (active.width() / 2));
        left = calcMenu.offset().left + (window.innerWidth / 2) - active.offset().left - (active.width() / 2);


        left = left < 0 ? left : 0;
        calcMenu.css({ transform: 'translateX(' + (left) + 'px)' });

    }


    $('.calcMenu__item').click(function () {
        if ($(this).hasClass('checked')) {
            console.log($(this).data('num'));
            changeStepTo($(this).data('num'));
            correctMenuSlider();
        }


    });


    $('.calc__stepItemLabel input').change(function () {
        let elsInput = $(this).parents('.calc__content').find('.calc__stepItemOptionLabel input');
        elsInput.each(function (i) {
            this.checked = false;
            this.disabled = true;
        });
        $(this).parents('.calc__content').find('.calc__stepItem').removeClass('active');

        if ($(this).is(':checked')) {
            $(this).parents('.calc__stepItem').find(' .calc__stepItemOptions input').each(function (i) {

                this.checked = false;
                this.disabled = false;
                if (i == 0) {
                    this.checked = true;
                }
            });
            $(this).parents('.calc__stepItem').addClass('active');
            $(this).parents('.calc__stepItem').find('.calc__stepItamImage')[0].src = $(this).data('image');


        }
    });

    $('.calc__navNext').click(function () {
        changeStepTo(calcStep + 1);
    });
    $('.calc__navPrev').click(function () {
        if (calcStep > 1)
            changeStepTo(calcStep - 1);
    });

    $('.calc__navSend').click(function () {
        document.querySelector('.wpcf7-form input[type=submit]').click();
    });

    $('.wpcf7-form input[name=formRodo]').change(function () {
        if ($(this).is(':checked')) {
            $('.calc__navSend').removeClass('disabled');
        } else {
            $('.calc__navSend').addClass('disabled');
        }
    });



    $('.calc__stepItemOptions input').change(function () {
        if ($(this).is(':checked')) {
            $(this).parents('.calc__stepItem').find('.calc__stepItamImage')[0].src = $(this).data('image');
        }
    });

    $('.calc__dimensionContent input[type=checkbox]').change(function () {
        if ($(this).is(':checked')) {
            $(this).parents('.calc__dimensionContent').find('#calcCFBWidth')[0].disabled = true;
        } else {
            $(this).parents('.calc__dimensionContent').find('#calcCFBWidth')[0].disabled = false;
        }
    });
    $('.calc__dimensionContent input[type=checkbox]').change();



    $('.calc__stepItemImageHolder').click(function () {
        $(this).parent().find('.calc__stepItemLabel input').click();
    });

    $('#calcDataForm input').change(function () {
        let calcData = $('#calcDataForm').serializeArray();
        let calcData2 = {};
        for (const key in calcData) {
            const item = calcData[key];
            calcData2[item.name] = item.value;
        }
        $('#calcData').val(JSON.stringify(calcData2));
    });

};